const HeaderScript = () => {
  return (
    <script
      dangerouslySetInnerHTML={{
        __html: `
          if(!!navigator.userAgent.match(/bybit_app/i)){
            const htmDom = document.documentElement;
            if(htmDom) {
              htmDom.classList.add("is-app-header");
            }
          }
        `,
      }}
    />
  );
};

export default HeaderScript;
